import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionCommand, ActionCommandService } from '../../../../services/action-command.service';
import { MenuStateService } from '../../../../services/menu-state.service';
import { SangriaSuprimentoService } from '../../../../services/sangria-suprimento.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { Sangria } from '../../../../models/sangria.model';
import { Suprimento } from '../../../../models/suprimento.model';

@Component({
  selector: 'app-withdrawal-list',
  imports: [CommonModule, TableModule, ButtonModule],
  templateUrl: './withdrawal-list.component.html'
})
export class WithdrawalListComponent implements OnInit, OnDestroy, ActionCommand {

  activeTab: 'sangrias' | 'suprimentos' = 'sangrias';
  sangrias: Sangria[] = [];
  suprimentos: Suprimento[] = [];
  loadingSangrias = false;
  loadingSuprimentos = false;

  constructor(
    @Inject(ActionCommandService) private actionCommandService: ActionCommandService,
    @Inject(MenuStateService) private menuStateService: MenuStateService,
    private sangriaSuprimentoService: SangriaSuprimentoService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
    this.loadSangrias();
    this.loadSuprimentos();
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.goBack(),
      getDescription: () => 'Voltar'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('ESC');
  }

  private getPdvId(): number | null {
    const id = localStorage.getItem('pdvId');
    return id ? parseInt(id, 10) : null;
  }

  loadSangrias(): void {
    this.loadingSangrias = true;
    const idpdv = this.getPdvId();

    this.sangriaSuprimentoService.getSangrias(idpdv).subscribe({
      next: (list) => {
        this.sangrias = list ?? [];
        this.loadingSangrias = false;
      },
      error: () => {
        this.sangrias = [];
        this.loadingSangrias = false;
      }
    });
  }

  loadSuprimentos(): void {
    this.loadingSuprimentos = true;
    const idpdv = this.getPdvId();

    this.sangriaSuprimentoService.getSuprimentos(idpdv).subscribe({
      next: (list) => {
        this.suprimentos = list ?? [];
        this.loadingSuprimentos = false;
      },
      error: () => {
        this.suprimentos = [];
        this.loadingSuprimentos = false;
      }
    });
  }

  setTab(tab: 'sangrias' | 'suprimentos'): void {
    this.activeTab = tab;
  }

  goBack(): void {
    this.menuStateService.goBackToMainMenu();
  }

  getKey(): string {
    return 'ESC';
  }

  execute(): void {
    this.goBack();
  }

  getDescription(): string {
    return 'Voltar';
  }
}
